module.exports = __webpack_public_path__ + "static/media/journey-data.0ab265d5.png";